<template>
  <div class="text--primary">
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && !comprasProdutos.length">
      <v-card-text>
        Nenhuma compra encontrada
      </v-card-text>
    </div>
    <v-simple-table v-if="!loading && comprasProdutos.length" class="rounded-card mb-3">
      <template v-slot:default>
        <thead>
        <tr>
          <th>Identificador</th>
          <th>Data compra</th>
          <th>Quantidade</th>
          <th>Preço unitário</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in comprasProdutos" :key="index">
            <td>
              #{{ item.compra.id }}
              <px-span-tooltip
                v-if="item.compra.codigoInterno"
                bottom
                text-class="caption"
                :text="`(${item.compra.codigoInterno})`"
                tooltip="Código no ERP"/>
            </td>
            <td>
              {{ item.compra.dataCompra | date }}
            </td>
            <td>
              {{ item.quantidade }} {{ item.unidadeMedida.descricao }}
            </td>
            <td>
              {{ item.valorMoedaConvertido.precoUnitario | currency }}
              <px-moeda-chip v-if="isMoedaEstrangeiraFn(item.compra.moeda)"
                             :moeda="item.compra.moeda"/>
              <div class="caption" v-if="isMoedaEstrangeiraFn(item.compra.moeda)">
                {{ item.precoUnitario | currency(simboloMoedaFn(item.compra.moeda),
                item.produto.casasDecimais,
                configuracaoFormatacaoMoedaFn(item.compra.moeda)) }}
              </div>
            </td>
            <td>
              <px-compra-detalhes-dialog-view :compra-id="item.compra.id" />
              <v-btn icon target="_blank" link :to="`/compra/${item.compra.id}/detalhes`">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import ComprasProdutosService from '@/modules/compra/compra-produtos/compras-produtos-service';
import moedaMixin from '@/mixins/moeda-mixin';

export default {
  mixins: [moedaMixin],
  props: {
    produto: {
      type: Object,
      required: true,
    },
    maxCompras: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      loading: false,
      comprasProdutos: [],
    };
  },
  methods: {
    getComprasProdutos() {
      this.loading = true;
      const query = `produto.id = ${this.produto.id} and situacaoCompra not in ('RECUSADA', 'CANCELADA', 'RASCUNHO') order by dataRegistro desc`;
      ComprasProdutosService.getComprasProdutos({ query, limit: this.maxCompras })
        .then(({ data }) => {
          this.comprasProdutos = data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getComprasProdutos();
  },
  components: {
    pxCompraDetalhesDialogView: () => import('@/modules/compra/detalhes/CompraDetalhesDialogView.vue'),
  },
};
</script>
